import React, { useContext, useState } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import ProjectsPage from './projects/ProjectsPage';
import 'bulma/css/bulma.css';
import '@creativebulma/bulma-tooltip/dist/bulma-tooltip.css';
import './App.css';
import { Button, Container, Form, Navbar } from "react-bulma-components";
import ProjectPage from "./projects/ProjectPage";
import useSWR from "swr";
import { fetcher } from "./utils/fetch";
import BillsPage from "./bills/BillsPage";

// TODO: Figure out how to change this
export const ACCOUNT_ID = 1;
export const HOME_ID = 6;
export const PROJECT_ID = 7;

export const HomesteadAuthorization = React.createContext({
    header: null,
    logout: () => {
    }
});

function NavigationMenu() {
    const authorization = useContext(HomesteadAuthorization);
    const { data, error } = useSWR('/api/me', fetcher);

    if (!data || error) {
        // TODO
        return <div/>
    }

    return (
        <Navbar.Menu>
            <Navbar.Container>
                <Navbar.Item to="/" renderAs={ Link }>
                    Home
                </Navbar.Item>

                <Navbar.Item to="/projects" renderAs={ Link }>
                    Projects
                </Navbar.Item>

                <Navbar.Item to="/inventory" renderAs={ Link }>
                    Inventory
                </Navbar.Item>

                <Navbar.Item to="/bills" renderAs={ Link }>
                    Bills
                </Navbar.Item>
            </Navbar.Container>

            <Navbar.Item hoverable href="#">
                <Navbar.Link>
                    { data.name }
                </Navbar.Link>

                {/* TODO */ }
                <Navbar.Dropdown right>
                    <Navbar.Item href="#">
                        Settings
                    </Navbar.Item>
                    <Navbar.Divider/>
                    <Navbar.Item onClick={ authorization.logout } textColor="danger">
                        Log out
                    </Navbar.Item>
                </Navbar.Dropdown>
            </Navbar.Item>
        </Navbar.Menu>
    );
}

function Navigation() {
    const authorization = useContext(HomesteadAuthorization);
    const [isOpen, setOpen] = useState(false);

    let menu;
    if (authorization.header) {
        menu = <NavigationMenu />;
    }

    return (
        <Navbar active={ isOpen } className="has-background-white-bis">
            <Navbar.Brand>
                <Navbar.Item>
                    <span className="has-text-weight-bold">Homestead</span>
                </Navbar.Item>

                <Navbar.Burger onClick={ () => setOpen(!isOpen) }/>
            </Navbar.Brand>

            { menu }
        </Navbar>
    );
}

// TODO: This needs to handle validation, and errors
export function LoginPage({ onSuccess }) {
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();

    const onSubmit = async (e) => {
        e.preventDefault();

        // Try and access /me with those credentials
        try {
            const response = await fetch('/api/me', {
                headers: {
                    'Authorization': 'Basic ' + btoa(`${ username }:${ password }`)
                }
            });

            if (response.status === 200) {
                onSuccess(username, password);
                // TODO: Store the authentication information somewhere
            } else {
                // TODO: Display an error
            }
        } catch (e) {
            // TODO
            console.error(e);
        }
    }

    return (
        <div>
            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>Username</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input onChange={ e => setUsername(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>

            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>Password</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input type="password" onChange={ e => setPassword(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>

            <Form.Field>
                <Form.Control>
                    <Button color="link" onClick={ onSubmit }>
                        Log in
                    </Button>
                </Form.Control>
            </Form.Field>
        </div>
    )
}


function App() {
    const [authorizationHeader, setAuthorizationHeader] = useState(localStorage.getItem('authorizationHeader'));

    const onLoginSuccess = (username, password) => {
        const header = 'Basic ' + btoa(`${ username }:${ password }`);
        localStorage.setItem('authorizationHeader', header);
        setAuthorizationHeader(header);
    };

    const onLogout = () => {
        localStorage.removeItem('authorizationHeader');
        setAuthorizationHeader(null);
    };


    const authorization = {
        header: authorizationHeader,
        logout: onLogout
    };

    let content;
    if (authorizationHeader) {
        content = (
            <Routes>
                <Route path="/" element={ <div/> }/>
                <Route path="/bills" element={ <BillsPage/> }/>
                <Route path="/projects" element={ <ProjectsPage/> }/>
                <Route path="/projects/:id" element={ <ProjectPage/> }/>
            </Routes>
        );
    } else {
        content = <LoginPage onSuccess={ onLoginSuccess }/>
    }

    return (
        <HomesteadAuthorization.Provider value={ authorization }>
            <div className="is-flex is-flex-direction-column">
                <Navigation/>

                <Container className="is-full-width" px={ 5 }>
                    { content }
                </Container>
            </div>
        </HomesteadAuthorization.Provider>
    );
}

export default App;
